<template>
  <div id="NonFound404">
    <div class="layout__content__header">
      <h1 class="">
        {{ $t("NotFound404") }}
      </h1>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
